export default __webpack_public_path__ + "static/lasting_memory-2bcbf2955948cfcc5ca2ea111ca14647.png";